import * as React from "react";
const SvgFiRrTurkey = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-turkey_svg__a)">
      <path
        fill="#062147"
        d="M19.85 10.755a5.04 5.04 0 0 0-.17-3.03c.038-.012 1.482-1.481 1.513-1.5a1.5 1.5 0 1 0 .649-2.063 1.5 1.5 0 1 0-2.063.649c-.015.022-1.5 1.482-1.5 1.507-1.424-.764-4.375 0-6.134.964C6.193 5.8.029 9.471 0 16v2.568a5.026 5.026 0 0 0 4.3 4.951C10.447 24.5 23.753 24.34 24 18c0-2.447-1.552-5.133-4.15-7.245m-5.207-2.367c1.435-.481 2.635-.516 3.06-.092.965.965-.563 5.139-2.181 6.757C12.461 18 8 13.538 10.947 10.478a10.6 10.6 0 0 1 3.696-2.09M9 22a37 37 0 0 1-4.419-.461A3.015 3.015 0 0 1 2 18.568V16a6.956 6.956 0 0 1 7.571-6.97c-5.795 6.95 5.914 14.078 9.632 3.8C26.5 20.17 18.3 21.918 9 22M7 3V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0m4 0V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0M3 3V1a1 1 0 0 1 2 0v2a1 1 0 0 1-2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-turkey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTurkey;
